import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=53254c63&scoped=true&"
import script from "./Blog.vue?vue&type=script&lang=js&"
export * from "./Blog.vue?vue&type=script&lang=js&"
import style0 from "./Blog.vue?vue&type=style&index=0&id=53254c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53254c63",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/home/bitrix/frontend/components/landing/Banner.vue').default,NewsFilters: require('/home/bitrix/frontend/components/news/NewsFilters.vue').default,NewsList: require('/home/bitrix/frontend/components/other/NewsList.vue').default,Pagination: require('/home/bitrix/frontend/components/other/Pagination.vue').default,Preloader: require('/home/bitrix/frontend/components/other/Preloader.vue').default})
